import { select, takeEvery } from '@redux-saga/core/effects';
import { AnalyticsTarget } from 'enums/AnalyticsTarget';
import { WsAction } from 'enums/WsAction';
import { DefaultRootState } from 'react-redux';
import { all, put } from 'redux-saga/effects';
import { services } from 'services/container';
import { createReachGoalActionBy } from 'utils/analytics';

import { CSIActionType, setCsiState, SetCsiStateAction } from './csi.actions';

interface ICsiData {
    rate?: number;
    text?: string;
    rejected?: boolean;
}

function* csiSendSaga() {
    yield takeEvery(CSIActionType.Send, function* () {
        const csi: DefaultRootState['csi'] = yield select((state: DefaultRootState) => state.csi);
        const { rating, likes, dislikes, comment, rejected } = csi;

        const data: ICsiData = {};

        if (rejected) {
            data.rejected = rejected;
        } else {
            data.rate = rating;

            const text = [...likes, ...dislikes, comment].join(';');

            if (text) {
                data.text = text;
            }
        }

        services.vo.wsSend({
            action: WsAction.CsiReply,
            data,
        });
    });
}

function* setCsiStateSaga() {
    yield takeEvery(CSIActionType.setCsiState, function* (action: SetCsiStateAction) {
        const { wasReceived, hasBeenRead } = action.payload;

        if (wasReceived && hasBeenRead) {
            services.analytics.send(createReachGoalActionBy(AnalyticsTarget.SHOW_CSI_FORM));

            services.vo.wsSend({
                action: WsAction.CsiReceived,
            });

            put(
                setCsiState({
                    hasBeenRead: false,
                    wasReceived: false,
                }),
            );
        }
    });
}

export function* csiSaga() {
    yield all([csiSendSaga(), setCsiStateSaga()]);
}
